import { media } from 'src/common/styles/breakpoints';
import styled, { css } from 'styled-components';

export const ConsentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: scroll;
  margin-right: -5px;
  padding-right: 5px;

  ::-webkit-scrollbar {
    border-left: 4px solid transparent;
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #d7d7d7;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb:hover {
    filter: brightness(0.2);
  }

  ${media.w.min.px576(css`
    height: 18.75rem;
    max-height: 18.75rem;
  `)};
`;
